import { render, staticRenderFns } from "./ProductDownloadAccordion.vue?vue&type=template&id=2d20e868&"
import script from "./ProductDownloadAccordion.vue?vue&type=script&lang=js&"
export * from "./ProductDownloadAccordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports